import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d08a956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "VerificationDataBox" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content-left" }
const _hoisted_4 = { class: "top" }
const _hoisted_5 = { class: "bottom" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"10px 0","color":"red","text-align":"center"} }, " 组织机构 ", -1))
const _hoisted_7 = { class: "scrollable-tree" }
const _hoisted_8 = { class: "content-right" }
const _hoisted_9 = {
  class: "operationCont",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_10 = { class: "farmerManagement-table" }
const _hoisted_11 = { class: "paginationCont" }
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "dialog-footer" }

import { useRouter } from "vue-router";
import { ElMessage, FormRules, ElTree, FormInstance } from "element-plus";
import {
  ref,
  reactive,
  onMounted,
  getCurrentInstance,
  toRaw,
  nextTick,
  onUnmounted,
  watch,
} from "vue";
import {
  getDeptTree,
  getFarmerPage,
  downLoadZip,
  saveFarmer,
  getAccessAly,
} from "@/views/VerificationData/api.js";
import { setField } from "../../utiles/utiles";
import { Search, RefreshRight, Plus, Download } from "@element-plus/icons-vue";
import { cardType, download } from "@/utiles/utiles";
import type { UploadProps } from "element-plus";

import { v4 as uuidv4 } from "uuid";
import OSS from "ali-oss";

interface IqueryForm {
  condition: {
    farmerName: string;
    idCard: string;
    deptId: string;
    deptIdsParams: any[]; // 这里可以是任意类型的数组
  };
  pageIndex: number;
  pageSize: number;
}
interface ruleFormConfigItem {
  id: string;
  farmerName: string;
  deptName: string;
  certificateType: string;
  phone: string;
  idCard: string;
  addr: string;
  url: string | null;
}

interface AddForm {
  farmerName: string;
  idCard: string;
  phone: string;
  deptId: string;
  compCode: string;
  addr: string;
  certificateImageType: string;
  url: string;
}
// 新建农户form

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const formSize = ref("default");
const ruleFormRef = ref();
const FormRef = ref();
const Router = useRouter();

const pageSizes = ref([10, 20, 50]);
const hasInitialSearch = ref(false);

const userManuallySetPageSize = ref(false);
const calculateTableRows = () => {
  // 如果用户手动设置了页面大小，则不进行自动计算
  if (userManuallySetPageSize.value) {
    return;
  }
  const tableContainer = document.querySelector(".farmerManagement-table");
  if (!tableContainer) {
    console.log("未找到表格容器");
    return;
  }

  const allRows = document.querySelectorAll(".el-table__row");
  if (!allRows.length) {
    if (!hasInitialSearch.value) {
      hasInitialSearch.value = true;
      onSearch(false);
    }
    return;
  }

  // 计算新的 pageSize
  const totalHeight = Array.from(allRows).reduce((sum, row) => {
    return sum + row.getBoundingClientRect().height;
  }, 0);
  const rowHeight = totalHeight / allRows.length;
  const containerHeight = tableContainer.clientHeight;
  const tableHeader = document.querySelector(".el-table__header");
  const headerHeight = tableHeader
    ? tableHeader.getBoundingClientRect().height
    : 0;
  const availableHeight = containerHeight - headerHeight;
  const maxRows = Math.floor(availableHeight / rowHeight);
  const calculatedSize = Math.ceil(maxRows / 5) * 5;

  if (queryForm.pageSize === calculatedSize) {
    return; // 如果分页大小没变，直接返回
  }

  // 更新分页相关配置
  pageSizes.value = [calculatedSize, calculatedSize * 2, calculatedSize * 3];
  defaultPageSize.value = calculatedSize;
  queryForm.pageSize = calculatedSize;
  onSearch(true);
};
const defaultPageSize = ref(10);
const queryForm = reactive<IqueryForm>({
  condition: {
    farmerName: "",
    idCard: "",
    deptId: "",
    deptIdsParams: [],
  },
  pageIndex: 1,
  pageSize: defaultPageSize.value,
});

const ruleForm = reactive<ruleFormConfigItem>({
  id: "",
  farmerName: "",
  deptName: "",
  certificateType: "",
  phone: "",
  idCard: "",
  addr: "",
  url: "",
});

const dialogVisible = ref(false);
const dialogTitle = ref<string>("养殖户信息");
const ossUrl = ref<string>("");
const cardTypeList = ref<any>(cardType);
const tableData = ref<any>([]);
const selectTableRows = ref<any>([]);
const total = ref(0);
const { proxy }: any = getCurrentInstance();
const treeRef = ref<InstanceType<typeof ElTree> | null>(null);
const deptTree = ref<any>([]);
const deptIdsParams = ref([] as any[]);
const addModalVisible = ref(false);
const addFormRef = ref<FormInstance>();
const downLoading = ref<boolean>(false);
const uploadAction = ref<string>(
  `${process.env.VUE_APP_URL}/farmer/importFarmers`
);

const userInfo = sessionStorage.getItem("userInfo")
  ? JSON.parse(sessionStorage.getItem("userInfo") || "")
  : "";
const actionHeaders = {
  Authorization: `Bearer ${
    localStorage.getItem(`token:${userInfo?.id}`) || ""
  }`,
  token: localStorage.getItem(`token:${userInfo?.id}`) || "",
};

// 定义新建农户form
const addForm = reactive<AddForm>({
  farmerName: "",
  idCard: "",
  phone: "",
  compCode: "",
  deptId: "",
  addr: "",
  certificateImageType: "",
  url: "",
});

const addFormRules = reactive<FormRules>({
  deptId: [
    {
      required: true,
      message: "请选择机构",
      trigger: "change",
    },
  ],
  farmerName: [{ required: true, message: "请输入农户姓名", trigger: "blur" }],
  idCard: [{ required: true, message: "请输入证件号", trigger: "blur" }],
  certificateImageType: [
    { required: true, message: "请选择证件类型", trigger: "blur" },
  ],
  phone: [{ required: false }],
  addr: [{ required: false }],
  url: [{ required: false }],
});

let aliossData = {
  region: "",
  accessKeyId: "",
  accessKeySecret: "",
  bucket: "",
  bucketName: "",
  endpoint: "",
  catalogue: "",
}; // 存储 OSS 配置信息
const uploadImageAction = ref(""); // OSS 上传地址
const fileList = ref([]);

const uploadRef = ref(null);

onMounted(() => {
  nextTick(() => {
    calculateTableRows();
  });
  let name = toRaw(Router).currentRoute.value.name;
  proxy.$doResize(name);
  getDeptTreeFn();
  // onSearch(true);
  getAccessAlyFn();
  const debouncedCalculate = debounce(calculateTableRows, 200);
  window.addEventListener("resize", debouncedCalculate);
});
watch(
  tableData,
  () => {
    if (tableData.value.length > 0) {
      // 只在有数据时才重新计算
      nextTick(() => {
        calculateTableRows();
      });
    }
  },
  { immediate: false }
);
onUnmounted(() => {
  window.removeEventListener("resize", calculateTableRows);
  userManuallySetPageSize.value = false;
});
const debounce = (fn: Function, delay: number) => {
  let timer: any = null;
  return function (this: any, ...args: any[]) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      userManuallySetPageSize.value = false; // 重置标志位
      fn.apply(this, args);
    }, delay);
  };
};

// 获取阿里云配置信息
const getAccessAlyFn = async () => {
  try {
    const response = await getAccessAly();
    localStorage.setItem("alioss", JSON.stringify(response));
    aliossData = response || JSON.parse(localStorage.getItem("alioss") || "{}");
    uploadImageAction.value = aliossData.endpoint; // 设置上传地址
    aliossData.bucket = aliossData.bucketName;
  } catch (error) {
    ElMessage.error("获取 OSS 配置信息失败");
  }
};

const beforeUpload = (file: any) => {
  // 此处可以添加文件大小或类型的校验
  return true;
};

const customHttpRequest = async (options: any) => {
  const { file } = options;
  const uuid = uuidv4().replace(/-/g, "");
  const fileName = uuid + file.name.substring(file.name.lastIndexOf("."));
  const client = new OSS(aliossData);
  try {
    const result = await client.put(aliossData.catalogue + fileName, file);
    const { url } = result;
    addForm.url = url;

    // TODO: 这里你可能需要将上传的文件地址发送到你的后端服务器
  } catch (e) {
    console.error("上传失败:", e);
    ElMessage.error("图片上传失败");
  }
};

// 新建农户 移除url
const handleRemove = () => {
  addForm.url = "";
  if (uploadRef.value) {
    uploadRef.value.clearFiles();
  }
};
const handlePreview = (uploadFile: File) => {
  console.log(uploadFile);
};

const handleClose = (formEl: any, type: Boolean) => {
  ruleForm.id = "";
  if (type) {
    dialogVisible.value = false;
  }
};
const handleSelectionChange = (value: any) => {
  selectTableRows.value = value;
};
const photoDownload = () => {
  if (!selectTableRows.value.length) {
    ElMessage({
      message: "请先选择农户",
      type: "warning",
    });
    return;
  }
  const farmerIds = selectTableRows.value.map((item: { id: any }) => {
    return item.id;
  });
  downLoadZip({ farmerIds: farmerIds, fileName: "农户标的.zip" }).then(
    (res: any) => {
      ElMessage({
        message: "下载成功",
        type: "success",
      });
    }
  );
};
const onSearch = (type: boolean) => {
  if (type) {
    queryForm.pageIndex = 1;
  }
  if (treeRef.value) {
    queryForm.condition.deptIdsParams = deptIdsParams.value as any[];
  }
  getFarmerPage(queryForm).then((res: any) => {
    const { items, totalSize } = res;
    total.value = Number(totalSize);
    tableData.value = items;
  });
};
const getDeptTreeFn = () => {
  getDeptTree().then((res: any) => {
    deptTree.value = res;
    addForm.deptId = deptTree.value[0].value;
    addForm.compCode = deptTree.value[0].compCode;
  });
};
const resetForm = (formEl: any) => {
  if (!formEl) return;
  if (treeRef.value) {
    treeRef.value.setCheckedKeys([]); // 清空选中状态
  }
  deptIdsParams.value = [];
  queryForm.condition.deptIdsParams = deptIdsParams.value as any[];
  addForm.compCode = "";
  addForm.deptId = "";
  formEl.resetFields();
  onSearch(true);
};
const viewDetails = (row: any) => {
  dialogTitle.value = "养殖户信息";
  dialogVisible.value = true;
  ossUrl.value = row.ossUrl;
  setTimeout(() => {
    for (let key in row) {
      const k = key as keyof ruleFormConfigItem;
      setField(ruleForm, k, row[k]);
    }
    row.url && (ruleForm.url = row.ossUrl + row.url);
  }, 200);
};
const handleSizeChange = (val: number) => {
  userManuallySetPageSize.value = true; // 设置标志位表示用户手动修改了页面大小
  queryForm.pageSize = val;
  onSearch(true);
};
const handleCurrentChange = (val: number) => {
  queryForm.pageIndex = val;
  onSearch(false);
};

const defaultProps = {
  children: "children",
  label: "label",
};

const handleCheck = (checkedNode, { checkedKeys, halfCheckedKeys }) => {
  if (treeRef.value) {
    const allCheckedKeys = [...checkedKeys, ...halfCheckedKeys];
    deptIdsParams.value = allCheckedKeys;

    queryForm.condition.deptIdsParams = deptIdsParams.value;
    if (checkedNode) {
      addForm.compCode = checkedNode.compCode;
      addForm.deptId = checkedNode.id;
    }
    onSearch(true);
  }
};

//  新建数据
const add = () => {
  // 如果勾选了组织机构使用勾选数据 否则使用默认值
  addForm.deptId = addForm.deptId || deptTree.value[0].value;
  addForm.compCode = addForm.compCode || deptTree.value[0].compCode;
  addModalVisible.value = true;
};

const changeCompCode = (item: any) => {
  addForm.compCode = item.compCode || "";
};

// 新建农户弹窗取消
const addModalOnClose = () => {
  if (addFormRef.value) {
    addFormRef.value.resetFields();
  }
  addModalVisible.value = false;
};
// 新建农户弹窗确认
const addModalOnConfirm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      saveFarmer(addForm)
        .then(() => {
          ElMessage.success("保存成功");
          addModalOnClose();
          resetForm(ruleFormRef.value);
        })
        .catch(() => {});
    } else {
      console.log("error submit!");
    }
  });
};

// 下载模板
const downloadTemplate = () => {
  if (downLoading.value) return;
  downLoading.value = true;
  const timeStamp = new Date().getTime();
  const url =
    process.env.VUE_APP_URL + `/farmer/downloadTemplate?timeStamp=${timeStamp}`;
  download(url, "新建农户模板.xlsx")
    .then(() => {
      downLoading.value = false;
    })
    .catch(() => {
      downLoading.value = false;
      ElMessage.error("下载失败，请稍后重试");
    });
};
// 导入数据成功
const uploadOnSuccess: UploadProps["onSuccess"] = (response, uploadFile) => {
  const { code, messages } = response;
  if (code === "S200") {
    ElMessage.success("导入成功");
    resetForm(ruleFormRef.value);
    onSearch(true);
    fileList.value = [];
  } else {
    if (messages && messages.length) {
      const errorMsgList = messages.map((n) => n.message);
      ElMessage.error(errorMsgList.join());
      fileList.value = [];
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Plus),
            onClick: add
          }, {
            default: _withCtx(() => [
              _createTextVNode("新 建")
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_upload, {
            "file-list": fileList.value,
            "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
            method: "post",
            class: "uploader ml-12",
            action: uploadAction.value,
            headers: actionHeaders,
            accept: ".xlsx, .xls",
            multiple: false,
            "show-file-list": false,
            limit: 1,
            "on-success": uploadOnSuccess
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, { type: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode("导入农户")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["file-list", "action"]),
          _createVNode(_component_el_button, {
            class: "ml-12",
            icon: downLoading.value ? null : _unref(Download),
            onClick: downloadTemplate,
            loading: !!downLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("下载模板")
            ]),
            _: 1
          }, 8, ["icon", "loading"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(ElTree), {
              modelValue: queryForm.condition.deptId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.condition.deptId) = $event)),
              ref_key: "treeRef",
              ref: treeRef,
              data: deptTree.value,
              "default-expand-all": "",
              "show-checkbox": "",
              "node-key": "id",
              props: defaultProps,
              "check-on-click-node": "",
              onCheck: handleCheck
            }, null, 8, ["modelValue", "data"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_form, {
            inline: true,
            model: queryForm,
            class: "demo-form-inline",
            ref_key: "ruleFormRef",
            ref: ruleFormRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "农户姓名",
                prop: "condition.farmerName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: queryForm.condition.farmerName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.condition.farmerName) = $event)),
                    placeholder: "农户姓名",
                    class: "unifiedInputBoxWidth"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "证件号码",
                prop: "condition.idCard"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: queryForm.condition.idCard,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.condition.idCard) = $event)),
                    placeholder: "证件号码",
                    class: "unifiedInputBoxWidth"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (onSearch(true))),
                    icon: _unref(Search)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查 询")
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  _createVNode(_component_el_button, {
                    plain: "",
                    icon: _unref(RefreshRight),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (resetForm(ruleFormRef.value)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("重 置")
                    ]),
                    _: 1
                  }, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_table, {
            data: tableData.value,
            border: "",
            style: {"width":"100%"},
            height: "100%",
            onSelectionChange: handleSelectionChange,
            onRowMounted: calculateTableRows
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55"
              }),
              _createVNode(_component_el_table_column, {
                type: "index",
                label: "序号",
                width: "60",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "deptName",
                label: "机构",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "farmerName",
                label: "农户姓名",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "idCard",
                label: "证件号码",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "phone",
                label: "电话",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "addr",
                label: "地址",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "created",
                label: "创建时间",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                fixed: "right",
                label: "操作",
                width: "120",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    link: "",
                    type: "primary",
                    size: "small",
                    onClick: _withModifiers(($event: any) => (viewDetails(scope.row)), ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 查看详情 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "total, sizes, prev, pager, next",
            "page-sizes": pageSizes.value,
            total: total.value,
            "current-page": queryForm.pageIndex,
            "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.pageIndex) = $event)),
            "page-size": queryForm.pageSize,
            "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.pageSize) = $event)),
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogVisible).value = $event)),
      center: "",
      title: dialogTitle.value,
      width: "500px",
      onClose: _cache[10] || (_cache[10] = ($event: any) => (handleClose(FormRef.value, true))),
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (handleClose(FormRef.value, true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("关 闭")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions, { column: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "姓名：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(ruleForm.farmerName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "组织机构：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(ruleForm.deptName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "证件类型：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(cardTypeList.value.find((v) => v.value == ruleForm.certificateType)
            ?.label), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "证件号码：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(ruleForm.idCard), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "联系电话：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(ruleForm.phone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "联系地址：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(ruleForm.addr), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "图片" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  style: {"width":"100%","height":"100%"},
                  src: ruleForm.url,
                  "zoom-rate": 1.2,
                  "max-scale": 7,
                  "min-scale": 0.2,
                  "preview-src-list": [ruleForm.url],
                  "initial-index": 4,
                  fit: "cover"
                }, null, 8, ["src", "zoom-rate", "min-scale", "preview-src-list"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: addModalVisible.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((addModalVisible).value = $event)),
      title: "新建农户",
      width: "500px",
      onClose: addModalOnClose,
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_el_button, { onClick: addModalOnClose }, {
            default: _withCtx(() => [
              _createTextVNode("取 消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (addModalOnConfirm(addFormRef.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确 定 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "addFormRef",
          ref: addFormRef,
          model: addForm,
          rules: addFormRules,
          "label-width": "80px",
          class: "demo-ruleForm",
          size: formSize.value,
          "status-icon": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "机构",
              prop: "deptId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tree_select, {
                  style: {"width":"100%"},
                  placeholder: "请选择机构",
                  "check-strictly": "",
                  clearable: "",
                  modelValue: addForm.deptId,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addForm.deptId) = $event)),
                  data: deptTree.value,
                  "render-after-expand": false,
                  onCurrentChange: changeCompCode
                }, null, 8, ["modelValue", "data"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "姓名",
              prop: "farmerName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addForm.farmerName,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((addForm.farmerName) = $event)),
                  clearable: "",
                  maxlength: "22",
                  placeholder: "请输入姓名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "证件类型",
              prop: "certificateImageType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: addForm.certificateImageType,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((addForm.certificateImageType) = $event)),
                  placeholder: "请选择证件类型",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "身份证",
                      value: "ID_CARD_FRONT"
                    }),
                    _createVNode(_component_el_option, {
                      label: "营业执照",
                      value: "BUSINESS_LICENSE"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "证件号码",
              prop: "idCard"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addForm.idCard,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((addForm.idCard) = $event)),
                  placeholder: "请输入证件号码",
                  maxlength: 30
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "电话",
              prop: "phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addForm.phone,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((addForm.phone) = $event)),
                  type: "number",
                  maxlength: "11",
                  placeholder: "请输入电话"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "地址",
              prop: "addr"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addForm.addr,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((addForm.addr) = $event)),
                  placeholder: "请输入地址",
                  type: "textarea",
                  "show-word-limit": "",
                  maxlength: "100",
                  autosize: { minRows: 4, maxRows: 6 }
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "图片",
              prop: "url"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "avatar-uploader",
                  action: uploadImageAction.value,
                  "show-file-list": false,
                  "before-upload": beforeUpload,
                  "http-request": customHttpRequest,
                  accept: ".jpg, .jpeg, .png",
                  "list-type": "picture-card",
                  "on-preview": handlePreview,
                  limit: 1,
                  ref_key: "uploadRef",
                  ref: uploadRef
                }, {
                  default: _withCtx(() => [
                    (addForm.url)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "remove-icon",
                          onClick: _withModifiers(handleRemove, ["stop"])
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_CloseBold)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_13))
                      : _createCommentVNode("", true),
                    (addForm.url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: addForm.url,
                          class: "avatar",
                          onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, _hoisted_14))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 2,
                          class: "avatar-uploader-icon"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Plus))
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["action"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "size"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})